import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "absolute h-screen bg-black bg-opacity-10 overflow-hidden inset-0 flex justify-end items-end sx:items-center sx:justify-center z-50 w-full mx-auto rounded shadow-xs"
}
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "flex items-start justify-start" }
const _hoisted_5 = { class: "mt-14 absolute ml-20 sx:mt-28 sx:ml-28" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.09 7.02l5.73-5.85a.68.68 0 00-.96-.95L7.13 6.06 1.17.2a.68.68 0 10-.95.97l5.95 5.84-5.95 5.84a.68.68 0 00.95.96l5.96-5.85 5.73 5.84a.68.68 0 00.96-.95L8.1 7.02z",
  fill: "#505050"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      ($props.center)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "header")
            ]),
            _createElementVNode("main", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createElementBlock("svg", {
                  class: "w-3 h-3 cursor-pointer",
                  viewBox: "0 0 14 14",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  onClick: _cache[0] || (_cache[0] = (...args) => ($options.close && $options.close(...args)))
                }, _hoisted_7))
              ]),
              _renderSlot(_ctx.$slots, "default")
            ])
          ]))
        : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-100",
              "enter-class": "transform opacity-0 scale-95",
              "enter-to-class": "transform opacity-100 scale-100",
              "leave-active-class": "transition ease-in duration-75",
              "leave-class": "transform opacity-100 scale-100",
              "leave-to-class": "transform opacity-0 scale-95"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            })
          ])), [
            [_directive_click_outside, $options.toggleModalState]
          ])
    ])
  ]))
}